import { render, staticRenderFns } from "./DataLogCollectModal.vue?vue&type=template&id=54578bd0&scoped=true&"
import script from "./DataLogCollectModal.vue?vue&type=script&lang=js&"
export * from "./DataLogCollectModal.vue?vue&type=script&lang=js&"
import style0 from "./DataLogCollectModal.vue?vue&type=style&index=0&id=54578bd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54578bd0",
  null
  
)

export default component.exports